import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/styles.scss';export default {
  "panel": "_panel_1wx4o_21",
  "panelContent": "_panelContent_1wx4o_33",
  "panelAnimateFromLeft": "_panelAnimateFromLeft_1wx4o_39",
  "popInFromLeft": "_popInFromLeft_1wx4o_1",
  "panelAnimateFromRight": "_panelAnimateFromRight_1wx4o_44",
  "popInFromRight": "_popInFromRight_1wx4o_1",
  "nameInput": "_nameInput_1wx4o_49",
  "field": "_field_1wx4o_64",
  "label": "_label_1wx4o_70",
  "reasonSelect": "_reasonSelect_1wx4o_76",
  "reasonSelectOpen": "_reasonSelectOpen_1wx4o_91",
  "reasonArrow": "_reasonArrow_1wx4o_96",
  "reasonArrowOpen": "_reasonArrowOpen_1wx4o_103",
  "reasonDropdown": "_reasonDropdown_1wx4o_107",
  "reasonOption": "_reasonOption_1wx4o_120",
  "reasonOptionSelected": "_reasonOptionSelected_1wx4o_130",
  "submitButton": "_submitButton_1wx4o_135",
  "enterIcon": "_enterIcon_1wx4o_160",
  "arrowLeft": "_arrowLeft_1wx4o_165",
  "arrowRight": "_arrowRight_1wx4o_166"
};